export const getSource = (url: string) => {
  const urlObj = new URL(url);
  const host = urlObj.hostname;
  if (host.includes('youtube')) {
    return 'youtube';
  }
  return 'podcast';
};

export const formatDate = (date: string) => {
  const dateTime = new Date(date);
  return dateTime.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const getEpisodeSlug = (title: string) => {
  const slug = title
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug;
};

export const getEpisodeUrl = (title: string, feedId: string) => {
  const slug = getEpisodeSlug(title);
  return `/podcast/${slug}/${feedId}`;
};

export const stripHtmlTags = (html: string): string => {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '');
};

export const normalizeToArray = <T>(value: T | T[] | undefined | null): T[] => {
  if (Array.isArray(value)) return value;
  if (value != null) return [value];
  return [];
};
